export default {
  tokenExpired: 'token过期，请重新登录',

  // Upload.vue
  uploadingTips: 'Please wait for all files to be uploaded successfully',
  uploadOkTips: 'Uploaded successfully',
  uploadErrorTips: 'File upload failed!',
  notFormatTips: 'File {0} does not support this format',
  maxSizeTips:
    'File {0} file size exceeds the maximum specified size, please compress and upload!',

  setMainImageBtn: 'First Picture',
  clickPreview: 'Click to enlarge',
  defaultUploadBtn: 'Upload File',
  ask: 'Do you confirm this operation?',
  confirm: 'Confirm',
  cancel: 'Cancel',
  success: 'Success',
  whiteImageBjMsg: 'Please choose a pure white background image',
  imageRequirements: 'Image requirements: the width and height are equal and the size is within 1 Mb. Drag and drop to adjust the order. Upload up to 10 images.'
}
